import { omit } from 'lodash';
import { TaskInput } from '~/generated/graphql';

export const taskTemplateToTaskInput = (task: any): TaskInput => {
  // Display attributes - ensure we handle objects with ids
  const attributes = (task.attributes as unknown[] | undefined)?.map
    ? (task.attributes as unknown[]).map((attr) =>
        typeof attr === 'object' && attr && 'id' in (attr as object)
          ? (attr as { id: string }).id
          : (attr as string)
      )
    : task.attributes || [];

  // Asset task config
  const assetTaskConfig = task.config
    ? omit(task.config, ['__typename'])
    : undefined;

  // Task-level tags (persisted via tagIds on TaskInput)
  // Prefer explicit tagIds if backend sends them, otherwise derive from tags connection if present.
  const tagIds: string[] =
    (task.tagIds as string[] | undefined) ??
    (task.tags?.nodes as { id: string }[] | undefined)?.map((tag) => tag.id) ??
    [];

  // Initialize result with common properties
  const result: TaskInput = {
    id: task.id,
    type: task.type,
    name: task.name,
    description: task.description,
    attributes, // Display attributes
    jobAttributes: task.jobAttributeIds,
    tagIds,
  };

  // Handle specific task types
  switch (task.type) {
    case 'Asset': {
      // Prefer explicit assets list if backend provides it (e.g. template tasks with specific assets)
      const assetIds: string[] =
        (task.assets as { id: string }[] | undefined)?.map(
          (asset) => asset.id
        ) ?? [];

      result.asset = {
        selection: task.config?.selection || 'specific', // Default to 'specific' if missing
        ...assetTaskConfig, // Include other config properties (spaces, assetTypes, allow, etc.)
        ...(assetIds.length > 0 ? { assets: assetIds } : {}),
      };
      break;
    }
    case 'Attribute':
      result.attribute = {
        attributes: task.attribute?.attributes || task.config?.attributes || [],
      };
      break;
  }

  return result;
};
